<div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
  <div class="wizard-steps" id="online-application">
    @for (navGroup of navGroups; track navGroup.id; let i = $index) {
      <wizard-vertical-nav-step [title]="navGroup | localizeNavGroupTitle"
        [svgIconName]="navGroup.svgIconName" [iconClass]="navGroup.iconClass" [index]="i"
        [state]="getWizardState(navGroup)"></wizard-vertical-nav-step>
    }
  </div>
</div>
